import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { trackFormInteraction } from '../helpers/checkoutTracking';
import styles from './styles/CheckoutAcknowledgement.scss';
import { connect } from 'react-redux';

import { Checkbox } from 'dibs-elements/exports/Checkbox';
import { Link } from 'dibs-elements/exports/Link';
import getBuyerSupportLink from 'dibs-support-link/exports/getBuyerSupportLink';
import CheckoutNeedsToAcknowledgeRestrictions from './CheckoutNeedsToAcknowledgeRestrictions';
import { toggleAcknowledgedRestrictionsAction } from '../actions/checkoutUIActions';

class CheckoutRestrictionAcknowledgement extends Component {
    constructor(props) {
        super(props);
        this.onToggle = this.onToggle.bind(this);
    }
    onToggle() {
        const { hasAcknowledgedRestrictions, dispatch } = this.props;
        if (!hasAcknowledgedRestrictions) {
            trackFormInteraction('restricted materials acknowledgement on review step selected');
        } else {
            trackFormInteraction('restricted materials acknowledgement on review step deselected');
        }
        dispatch(toggleAcknowledgedRestrictionsAction());
    }
    render() {
        const { transaction, hasAcknowledgedRestrictions } = this.props;
        return (
            <CheckoutNeedsToAcknowledgeRestrictions {...{ transaction }}>
                {({ needsToAcknowledgeRestrictions }) => {
                    if (!needsToAcknowledgeRestrictions) {
                        return null;
                    }
                    return (
                        <div className={styles.wrapper}>
                            <Checkbox
                                name="acknowledgeRestrictions"
                                wrapperClass={styles.checkbox}
                                checked={hasAcknowledgedRestrictions}
                                onChange={this.onToggle}
                                label={
                                    <div className={styles.label}>
                                        <FormattedMessage
                                            id="checkout.CheckoutRestrictionAcknowledgement.acknowledgment"
                                            defaultMessage="I acknowledge this item contains restricted materials, and am aware of the 6 to 8 weeks it may take to obtain the required permit, in addition to shipping and handling. <a>Learn more</a>"
                                            values={{
                                                a: content => (
                                                    <Link
                                                        href={getBuyerSupportLink(
                                                            '/en-us/articles/14517316102939/'
                                                        )}
                                                        target="_blank"
                                                    >
                                                        {content}
                                                    </Link>
                                                ),
                                            }}
                                        />
                                    </div>
                                }
                            />
                        </div>
                    );
                }}
            </CheckoutNeedsToAcknowledgeRestrictions>
        );
    }
}

CheckoutRestrictionAcknowledgement.propTypes = {
    transaction: PropTypes.object.isRequired,
    hasAcknowledgedRestrictions: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
};

const ConnectedCheckoutRestrictionAcknowledgement = connect(state => ({
    hasAcknowledgedRestrictions: state?.ui?.customerAcknowledgedRestrictions,
}))(CheckoutRestrictionAcknowledgement);

export default createFragmentContainer(ConnectedCheckoutRestrictionAcknowledgement, {
    transaction: graphql`
        fragment CheckoutRestrictionAcknowledgement_transaction on Transaction {
            ...CheckoutNeedsToAcknowledgeRestrictions_transaction
        }
    `,
});
